export * from "./qr-code-design-settings.component";
